import Reauthenticate from "@/components/Reauthenticate.vue";
import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { until } from "@vueuse/core";

export const useReauthenticateDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));
    const authenticationSuccess = ref(false);

    /**
     * Opens dialog and returns when the dialog is closed with
     * the authenticationSuccess value.
     */
    const open = async ({
        successCallback,
        failureCallback,
    }: {
        successCallback?: () => void;
        failureCallback?: () => void;
    } = {}) => {
        dialogRef.value = dialog.open(Reauthenticate, {
            props: {
                header: "Confirm Your Password",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
                closeOnEscape: false,
                closable: true,
            },
            data: {
                failureCallback: () => {
                    authenticationSuccess.value = false;
                    failureCallback?.();
                },
                successCallback: () => {
                    authenticationSuccess.value = true;
                    successCallback?.();
                },
            },
        });

        await until(isVisible).not.toBeTruthy();
        return authenticationSuccess.value;
    };

    return { open, isVisible };
};
